export default __webpack_public_path__ + "static/media/ourstory.0af7f421.jpeg";